/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureVaultConfigInput {
  /**
  * The tenant ID of the Azure subscription.
  */
  'tenantId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureVaultConfigInput.attributeTypeMap;
  }

  public constructor() {
  }
}

